import React, { Fragment, useContext } from 'react'
import PropTypes from 'prop-types'
import qs from 'query-string'
import StoreList from '../../components/store-list'
import withStores from '../../containers/with-stores'
import withStoreRetailCategories from '../../containers/with-store-retail-categories'
import withUserSettings from '../../containers/with-user-settings'
import withUpdateUserSettings from '../../containers/with-update-user-settings'
import pagesHoc from '../pages-hoc'
import { getRetailCategories } from '../../helpers/categories-helper'
import { getDisplayName } from '../../helpers/get-display-name'
import { BasicPageContext } from '../../context'

const BrowseStores = ({
  centreName,
  centreSlug,
  stores,
  centreCategories,
  history,
  match,
  location,
  isListView,
  updateBrowseStoresView,
}) => {
  const params = qs.parse(location.search)
  const isBasicPage = useContext(BasicPageContext)

  const createAddress = ({ path, filters }, { navigate = false } = {}) => {
    const address = {
      pathname: path
        ? `/${centreSlug}/browse-stores/${path}`
        : `/${centreSlug}/browse-stores`,
      search: qs.stringify({ ...params, ...filters }),
    }

    if (isBasicPage) {
      address.pathname = `/_basic${address.pathname}`
    }

    if (navigate) {
      history.replace(address, undefined, undefined, { shallow: true })
    }

    return address
  }
  return (
    <Fragment>
      <StoreList
        createAddress={createAddress}
        category={match.params.category}
        filters={{
          'gift-cards-accepted': Boolean(params['gift-cards-accepted']),
          'after-pay': Boolean(params['after-pay']),
        }}
        stores={stores}
        centreName={centreName}
        centreCategories={centreCategories}
        isListView={isListView}
        toggle={
          updateBrowseStoresView && (() => updateBrowseStoresView(!isListView))
        }
      />
    </Fragment>
  )
}

BrowseStores.propTypes = {
  history: PropTypes.object,
  location: PropTypes.object,
  match: PropTypes.object,
  centreName: PropTypes.string,
  centreSlug: PropTypes.string,
  stores: PropTypes.array,
  centreCategories: PropTypes.object,
  isListView: PropTypes.bool.isRequired,
  updateBrowseStoresView: PropTypes.func,
}

const getMetaData = ({ centre, match, centreCategories }) => {
  let categoryData = null
  if (match.params.category) {
    categoryData = centreCategories.categories.find(
      element => element.slug === match.params.category
    )
  }
  if (categoryData) {
    return {
      title: `${categoryData.title} Stores | Visit Westfield ${centre.title}`,
      description: `Westfield ${centre.title} ${categoryData.title} - View store locations, directions and more for ${categoryData.title} at Westfield ${centre.title}`,
    }
  } else {
    return {
      title: `Store Directory | All Stores at Westfield ${centre.title} `,
      description: `Use the centre map and directory to easily locate stores within our centre. Search all stores, or explore new favourites at Westfield ${centre.title}.`,
    }
  }
}

/* eslint-disable react/no-multi-comp */
const mutateRetailCategories = Component => {
  const WrappedComponent = props => (
    <Component
      {...props}
      centreCategories={
        props.centreCategories && getRetailCategories(props.centreCategories)
      }
    />
  )

  WrappedComponent.displayName = getDisplayName(Component)

  WrappedComponent.propTypes = {
    centreCategories: PropTypes.array,
  }

  return WrappedComponent
}
/* eslint-enable react/no-multi-comp */

export default withStoreRetailCategories(
  mutateRetailCategories(
    withStores(
      withUserSettings(
        withUpdateUserSettings(pagesHoc(BrowseStores, getMetaData))
      )
    )
  )
)
